import React, { Suspense } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import { Box, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";

export default function Invite(props) {
  const classes = useStyles();
  let history = useHistory();

  return (
    <div className={classes.root}>
      <Box
        className={classes.notfoundContainer}
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <Suspense fallback={<p>Loading stuff</p>}>
          <img
            src={require("../../assets/img/404.svg")}
            height="120"
            alt="svg"
          />
        </Suspense>

        {props.link ? (
          <>
            <Typography
              variant="h3"
              component="h3"
              className={classes.mainText}
            >
              Sorry! Page Not Found
            </Typography>

            <Typography
              variant="body1"
              component="p"
              className={classes.subText}
            >
              Please switch to the page compatible with your device screen size.
            </Typography>

            <Box mt={3}>
              <Button
                onClick={() => {
                  history.push(props.link);
                }}
                variant="contained"
                color="primary"
                style={{ color: "white", fontWeight: "bold" }}
              >
                Go to compatible page
              </Button>
            </Box>
          </>
        ) : (
          <>
            <Typography
              variant="h3"
              component="h3"
              className={classes.mainText}
            >
              Sorry! Page Not Found
            </Typography>

            <Typography
              variant="body1"
              component="p"
              className={classes.subText}
            >
              Unfortunately the page you are looking for has been moved or
              deleted
            </Typography>

            <Box mt={3}>
              <Button
                onClick={() => {
                  history.push(`/trade/BTC`);
                }}
                variant="contained"
                color="primary"
                style={{ color: "white", fontWeight: "bold" }}
              >
                Go to dashboard
              </Button>
            </Box>
          </>
        )}
      </Box>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    paddingTop: "50px",
    height: "100%",
  },
  notfoundContainer: {
    margin: "0 auto",
    borderRadius: 0,
    background: theme.palette.type === "dark" ? "#151828" : "white",
    minHeight: "600px",
    [theme.breakpoints.down("xs")]: {
      // minWidth: "450px",
    },
    [theme.breakpoints.up("sm")]: {
      maxWidth: "calc(100vw - 30%)",
    },
  },
  mainText: {
    color: theme.palette.text.primary,
    fontWeight: "bold",
    marginTop: "30px",
  },
  subText: {
    color: theme.palette.text.primary,
    opacity: 0.5,
    width: "300px",
    textAlign: "center",
    marginTop: "20px",
    fontSize: "1.0rem",
  },
}));
